const itemMenuLeft = `
<a href="#" data-id="{{id}}" class="{{class_active}}"><span>{{name}}</span>{{new}}</a>
`;

export default itemMenuLeft;